export default __webpack_public_path__ + "static/and-logo-4-7fba22b61d88254f9459ed00f68901ef.webp";